var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7714 6.93881L12.8474 6.59481C13.8564 6.27281 14.9344 6.79381 15.3664 7.81181L16.2264 9.83981C16.6004 10.7228 16.3924 11.7618 15.7124 12.4078L13.8174 14.2058C13.9344 15.2818 14.2964 16.3408 14.9024 17.3828C15.4779 18.3909 16.2498 19.2734 17.1724 19.9778L19.4484 19.2178C20.3104 18.9308 21.2504 19.2618 21.7784 20.0388L23.0114 21.8488C23.6264 22.7528 23.5154 23.9988 22.7524 24.7648L21.9354 25.5858C21.1214 26.4028 19.9584 26.6998 18.8834 26.3638C16.3434 25.5718 14.0104 23.2208 11.8804 19.3108C9.7474 15.3948 8.9944 12.0708 9.6224 9.34281C9.8864 8.19481 10.7034 7.27981 11.7714 6.93881Z",
    fill: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "#E87A46",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOrange);
export default __webpack_public_path__ + "static/media/PhoneOrange.343c9040ca052ccd7145a57189d9ecb0.svg";
export { ForwardRef as ReactComponent };